import '@uva-glass/component-library/dist/assets/globals.css';
import './css/base.css';
import './css/miscellaneous.css';
import './css/transitions.css';
import './css/typography.css';

import { createRoot } from 'react-dom/client';
import { use } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { loadRemote } from '@module-federation/runtime';

import type { HttpBackendOptions } from 'i18next-http-backend';

import { App } from './App';

const root = createRoot(document.getElementById('root')!);

const backendOptions: HttpBackendOptions = {
  async request(_options, url, _payload, callback) {
    const matches = url.match(/\/([a-z]{2})\/([\w-]+)\.json$/);
    //Prefix for namespaces
    const regexFacet = /^facet-/;
    const regexPrism = /^prism-/;
    const regexQuartz = /^quartz-/;
    const regexGobletLegacy = /^goblet-legacy-/;
    const regexGoblet = /^goblet-/;
    let result, data;

    if (!matches?.length) {
      callback(new Error(`Translation could not be found for ${url}`), { status: 404, data: ' ' });
      return;
    }

    const [, lang, ns] = matches;

    // Check if the namespace has a prefix, if so, load the remote module
    if (regexFacet.test(ns)) {
      result = await loadRemote(`facet/${lang}-${ns}`);
      data = JSON.stringify(result);
    } else if (regexPrism.test(ns)) {
      result = await loadRemote(`prism/${lang}-${ns}`);
      data = JSON.stringify(result);
    } else if (regexQuartz.test(ns)) {
      result = await loadRemote(`quartz/${lang}-${ns}`);
      data = JSON.stringify(result);
    } else if (regexGobletLegacy.test(ns)) {
      result = await loadRemote(`goblet-legacy/${lang}-${ns}`);
      data = JSON.stringify(result);
    } else if (regexGoblet.test(ns)) {
      result = await loadRemote(`goblet/${lang}-${ns}`);
      data = JSON.stringify(result);
    } else {
      result = await import(`assets/locales/${lang}/${ns}.json`);
      data = JSON.stringify(result.default);
    }

    callback(undefined, { status: 200, data });
  },
  loadPath: '/locales/{{lng}}/{{ns}}.json',
};

// eslint-disable-next-line react-hooks/rules-of-hooks
use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: ['common'],
    detection: {
      order: ['localStorage', 'navigator', 'cookie', 'htmlTag'],
    },
    interpolation: { escapeValue: false },
    load: 'languageOnly',
    cleanCode: true,
    supportedLngs: ['nl', 'en'],
    returnNull: false,
    missingKeyHandler(_: readonly string[], __: string, key: string) {
      console.warn('Missing translation for key: ', key);
    },
    backend: backendOptions,
  });

root.render(<App />);
